export default __webpack_public_path__ + "static/media/harvard-logo.2ac3242b.jpeg";